import Vue from 'vue';

// Запрещает скролл страницы и компенсирует ширину полосы прокрутки,
// чтобы визуально не было дерганий в интерфейсе
Vue.prototype.toggleNoScroll = (noScroll)=>{
  if (noScroll) {
    document.body.style.paddingRight = `${window.innerWidth - document.body.clientWidth}px`;
    document.body.classList.add('no-scroll');
    return;
  }
  document.body.classList.remove('no-scroll');
  document.body.style.paddingRight = '';
};

// Шина глобальных событий. ИСПОЛЬЗОВАТЬ ТОЛЬКО В КРАЙНЕМ СЛУЧАЕ
// Для обмена событиями между не связанными компонентами
Object.defineProperty(Vue.prototype, '$bus', {
  get: function() {
    return this.$root.bus;
  },
});
